import React, { Component } from 'react';

class HeadingsAndButtons extends Component {
    render() {
        return (
            <div className="headings-and-buttons">
                <h2 style={{ fontFamily: "var(--font-titles)", color: 'var(--foreground, #000)', fontWeight: 'bold' }}>This is a base heading</h2>
                <p style={{ color: 'var(--foreground, #000)', fontFamily: "var(--font-body)" }}>
                    This is base body text with <a href="#!" style={{ fontFamily: "var(--font-body)", color: 'var(--primary-button, #309AB5)', textDecoration: 'underline' }}>link text.</a>
                </p>
            </div>
        );
    }
}

export default HeadingsAndButtons;



// WEBPACK FOOTER //
// ./src/components/pages/in-context/components/HeadingsAndButtons.js